import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'CONTRACT';

export const {
    action: fetchContract,
    success: fetchContractSuccess,
    failed: fetchContractFailed,
} = createAction(
    `${domain}/FETCH`,
    (contractId, token) => ({contractId, token}),
    contract => ({contract}),
);

export const {
    action: acceptContract,
    success: acceptContractSuccess,
    failed: acceptContractFailed,
} = createAction(`${domain}/ACCEPT`, (contractId, token) => ({contractId, token}));

export const {action: showAcceptedModal} = createAction(`${domain}/SHOW_ACCEPT_MODAL`, show => ({show}));
